import "./index.css";

import zxcvbn from 'zxcvbn';

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const passwordInput = document.getElementById('zxcvbn-pass');

    if (!passwordInput) return;

    // const barFill = document.getElementById('bar-fill');
    const strength = document.getElementById('strength');
    const suggestions = document.getElementById('suggestions');

    const strengthLabels = ["✖ Very weak", "✖ Weak", "✖ Still weak", "✔ Good enough", "✔ Excellent!"];
    const strengthClasses = ["weak", "weak", "fair", "good", "strong"];

    passwordInput.addEventListener('input', () => {
      const password = passwordInput.value;

      const result = zxcvbn(password);
      const score = result.score;

      // barFill.style.width = ((score + 1) * 20) + "%";
      // barFill.className = "bar-fill " + strengthClasses[score];

      strength.textContent = strengthLabels[score];
      suggestions.textContent = result.feedback.suggestions.join("\. ").replace(/\.{2,}/, ".");

      document.querySelectorAll('.error').forEach(el => el.remove());

    });
  },
  false,
);
